import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import AdminBar from "components/Masterbar/AdminBar";
import { getSuppliers, selectSuppliers, selectSuppliersStatus } from "redux/slices/supplierSlice";
import { useParams } from "react-router-dom";
import { getUserById, selectSelectedUser, updateUser } from "redux/slices/userSlice";
import { getSupplierLocations, selectSupplierLocations } from "redux/slices/supplierLocationsSlice";
import UserForm from "components/Users/form";

const currentAction = "EDIT";
const EditUser = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const suppliers = useSelector(selectSuppliers);
  const supplierLocations = useSelector(selectSupplierLocations);
  const loading = useSelector(selectSuppliersStatus);
   const user = useSelector(selectSelectedUser);
 

  const { id } = useParams();

  useEffect(() => {
    if (id && !loading) {
      dispatch(getUserById(id));
    }
  }, [dispatch, id]);
    useEffect(() => {
      if (!suppliers.length && !loading) {
        dispatch(getSuppliers());
      }
      dispatch(getSupplierLocations());
    }, [dispatch]);
  const onSubmit = async (payload) => {
    await dispatch(updateUser(id, payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.users) : ""
    );
  };

  return (
    <>
      <Navbar />
      <AdminBar />
      <LightLayout doublebar loading={loading || !user}>
        <UserForm
          action={currentAction}
          initialValues={user}
          onSubmit={onSubmit}
                 suppliers={suppliers}
          supplierLocations={supplierLocations}
        />
      </LightLayout>
    </>
  );
};

export default EditUser;
